import Button from "@material-ui/core/Button";

import { label, root } from "./LoginSubmitButton.module.scss";

const LoginSubmitButton = (props) => (
  <Button type="submit" fullWidth classes={{ root, label }} {...props} />
);

export default LoginSubmitButton;
